import React, {useMemo} from "react";
import {Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip} from "recharts";
import {IMonthlyAttendance} from "./types/employee-attendance-card.types";
import EmptyData from "../../common/empty-data/empty-data";
import {CalendarCheck2} from "lucide-react";
import LoadingSkeleton from "../../common/loading-skeleton/loading-skeleton";

interface IEmployeeAttendanceCardView {
    attendanceData: IMonthlyAttendance | null;
    loading: boolean;
}

const EmployeeAttendancePieChart = (props: IEmployeeAttendanceCardView) => {

    const PIE_COLORS = [
        "var(--pn-chart-primary)",
        'var(--pn-chart-secondary)',
        'var(--pn-chart-quaternary)',
        'var(--pn-chart-neutral)',
        'var(--pn-chart-tertiary)',
        'var(--pn-chart-cancelled)',
    ];

    const chartData = useMemo(() => {
        if (!props) return [];

        return [
            {
                name: "Working Days",
                value: props.attendanceData?.workingDays,
            },
            {
                name: "Present Days",
                value: props.attendanceData?.presentDays,
            },

            {
                name: "Absent Days",
                value: props.attendanceData?.absentDays,

            },
            {
                name: "Holidays",
                value: props.attendanceData?.holidays,
            },
            {
                name: "Leave Days",
                value: props.attendanceData?.leaveDays,
            },
            {
                name: "Weekend Days",
                value: props.attendanceData?.weekends,
            },
        ];
    }, [props]);



    return (
        <LoadingSkeleton loading={props.loading}>
            <div className={"dashboard-admin-attendance-card-chart"} >
                {props.attendanceData ?
                    <section>
                        <ResponsiveContainer width="100%" height={200}>
                            <PieChart>
                                <Pie
                                    data={chartData}
                                    cx="50%"
                                    cy="50%"
                                    innerRadius={55}
                                    outerRadius={80}
                                    paddingAngle={3}
                                    dataKey="value"
                                    nameKey="name"
                                    stroke="none"
                                >
                                    {chartData.map((_, index) => (
                                        <Cell
                                            key={`cell-${index}`}
                                            fill={PIE_COLORS[index % PIE_COLORS.length]}
                                            stroke="none"
                                        />
                                    ))}
                                </Pie>

                                <Tooltip
                                    contentStyle={{
                                        background: '#FFFFFF',
                                        border: '1px solid #e2e8f0',
                                        borderRadius: '8px',
                                        fontSize: '12px',
                                        fontWeight: 600,
                                        color: '#0f172a',
                                    }}
                                />

                                <Legend
                                    layout="vertical"
                                    verticalAlign="middle"
                                    align="right"
                                    iconType="circle"
                                    iconSize={10}
                                    formatter={(value, entry: any) => {
                                        return (
                                            <span
                                                style={{
                                                    color: 'var(--pn-text-primary)',
                                                    fontSize: '13px',
                                                    fontWeight: 500,
                                                }}
                                            >
                {value} : {entry.payload.value}
            </span>
                                        );
                                    }}
                                />
                            </PieChart>
                        </ResponsiveContainer>
                    </section> :
                    <EmptyData
                        icon={<CalendarCheck2 className={'attendance-empty-data-icon'}/>}
                        title={"No Attendance Data Found"}
                        subtitle={" You have no recorded absences or attendance anomalies for the selected period."}
                    />
                }
            </div>
        </LoadingSkeleton>
    )
}

export default EmployeeAttendancePieChart;
